export const resolveConfiguracoesListagemEnabled = (override) => {
  if (typeof override === 'boolean') {
    return override;
  }

  return process.env.REACT_APP_ENABLE_CONFIGURACOES_LISTAGEM === 'true';
};
